import React from 'react';
import { Space, Checkbox, InputNumber } from 'antd';
import { WeeklyStrategy } from '../../ProfitScenario/types';

interface DiscountColumnProps {
    week: WeeklyStrategy;
    phaseId: string;
    index: number;
    updateWeekStrategy: (phaseId: string, weekIndex: number, updates: Partial<WeeklyStrategy>) => void;
}

export const DiscountColumn: React.FC<DiscountColumnProps> = ({
    week,
    phaseId,
    index,
    updateWeekStrategy
}) => {
    return (
        <Space size={4} wrap>
            {/* Prime Discount */}
            <Space size={2}>
                <Checkbox
                    checked={week.enablePrime}
                    onChange={e => updateWeekStrategy(phaseId, index, { enablePrime: e.target.checked })}
                >
                    Prime
                </Checkbox>
                {week.enablePrime && (
                    <InputNumber
                        size="small"
                        min={0}
                        max={100}
                        value={week.primeDiscount}
                        onChange={v => updateWeekStrategy(phaseId, index, { primeDiscount: v || 0 })}
                        suffix="%"
                        style={{ width: 55 }}
                    />
                )}
            </Space>

            {/* Coupon */}
            <Space size={2}>
                <Checkbox
                    checked={week.enableCoupon}
                    onChange={e => updateWeekStrategy(phaseId, index, { enableCoupon: e.target.checked })}
                >
                    Cpn
                </Checkbox>
                {week.enableCoupon && (
                    <InputNumber
                        size="small"
                        min={0}
                        max={100}
                        value={week.couponDiscount}
                        onChange={v => updateWeekStrategy(phaseId, index, { couponDiscount: v || 0 })}
                        suffix="%"
                        style={{ width: 55 }}
                    />
                )}
            </Space>

            {/* Lightning Deal */}
            <Space size={2}>
                <Checkbox
                    checked={week.enableLightningDeal}
                    onChange={e => updateWeekStrategy(phaseId, index, { enableLightningDeal: e.target.checked })}
                >
                    LD
                </Checkbox>
                {week.enableLightningDeal && (
                    <InputNumber
                        size="small"
                        min={0}
                        max={100}
                        value={week.lightningDealDiscount}
                        onChange={v => updateWeekStrategy(phaseId, index, { lightningDealDiscount: v || 0 })}
                        suffix="%"
                        style={{ width: 55 }}
                    />
                )}
            </Space>

            {/* Promotion */}
            <Space size={2}>
                <Checkbox
                    checked={week.enablePromotion}
                    onChange={e => updateWeekStrategy(phaseId, index, { enablePromotion: e.target.checked })}
                    disabled={week.enableCoupon}
                >
                    Promo
                </Checkbox>
                {week.enablePromotion && (
                    <>
                        <InputNumber
                            size="small"
                            min={0}
                            max={100}
                            value={week.promotionDiscount}
                            onChange={v => updateWeekStrategy(phaseId, index, { promotionDiscount: v || 0 })}
                            suffix="%"
                            style={{ width: 60 }}
                        />
                        <InputNumber
                            size="small"
                            min={0}
                            value={week.promotionDailyUnits}
                            onChange={v => updateWeekStrategy(phaseId, index, { promotionDailyUnits: v || 0 })}
                            style={{ width: 90 }}
                            addonAfter="销量"
                        />
                    </>
                )}
            </Space>
        </Space>
    );
};
